import CategoryGraph from './CategoryGraph.jsx'

export default CategoryGraph
